// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s8-0";
export var fileList = "_s8-2";
export var removeFileButton = "_s8-1";